angular.module('bmsApp.trugreen.job').controller('TGJobSaveCtrl', function ($state,
																				   $scope,
																				   $q,
																				   SecurityTypeSvc,
																				   TaxHelperSvc,
																				   notify,
																			       TGJobSvc) {


	$scope.formValidator = {};
	$scope.formvalidatorconfig = {};

	function init() {
		var promises = {
			quote: TGJobSvc.read($state.params.quoteId),
			appointmentTimes: TGJobSvc.preferredAppointmentTimes(),
			securityTypes: SecurityTypeSvc.options(),
			vatRate: TaxHelperSvc.setVatRate()
		};

		$q.all(promises).then(function (responses) {
			self.options.appointmentTimes = responses.appointmentTimes.data.options;
			self.quote = responses.quote.data.tg_job;
			self.options.securityTypes = responses.securityTypes.data.options;
			$scope.quoteName = self.quote.quote_name;
			$scope.jobId = self.quote.id;

			angular.extend($scope, {
				quote: {
					name: angular.copy(self.quote.quote_name)
				}
			});

			if (!self.quote.preferred_appointment_time) {
				self.quote.preferred_appointment_time = 'Anytime Treatment';
			}
			else if (self.quote.preferred_appointment_time === 'Specific') {
				self.quote.preferred_time = moment(self.quote.preferred_time, "HH:mm");
			}
			else {
				self.quote.preferred_time = '';
			}

			checkUnassignedTreatments();
			self.quote.hasSecurityCode = (self.quote.securityType || self.quote.property_access) ? "1" : "0";


		}).finally(function () {
			self.loading = false;
		});
	}

	function checkUnassignedTreatments() {
		var unassignedTreatments = 0;
		angular.forEach(self.quote.treatments, function (treatment) {
			if (!treatment.added_to_visit) {
				unassignedTreatments++;
			}
		});
		self.unassignedTreatmentsCount = unassignedTreatments;
	}

	function initSplitPayments() {
		if (!angular.isObject(self.quote.splitPayments)) {
			angular.extend(self.quote, {splitPayments: []});
		}

		if (self.quote.splitPayments.length === 0) {
			// add some payments by default - 6 months
			self.quote.splitPayments.push({
				date: moment(),
				net: TaxHelperSvc.netFromGross(self.quote.selling_price_gross),
				gross: self.quote.selling_price_gross
			});

			for (var i = 0; i < 5; i++) {
				addSplitPayment();
			}
		}
	}

	function addSplitPayment() {
		// get last date
		var payment = self.quote.splitPayments[self.quote.splitPayments.length - 1];
		self.quote.splitPayments.push(
			{
				date: moment(payment.date).add(1, 'month')
			});

		recalculateSplitPayments();

	}

	function removeSplitPayment() {
		if (self.quote.splitPayments.length > 1) {
			self.quote.splitPayments.splice(self.quote.splitPayments.length -1, 1);
			recalculateSplitPayments();
		}
	}

	function recalculateSplitPayments() {
		// get the total of all the custom payments
		var totalCustomPayments = 0;
		angular.forEach(self.quote.splitPayments, function(payment) {
			if (payment.custom) {
				totalCustomPayments += payment.gross;
			}
		});

		var equalGrossPayment = (self.quote.selling_price_gross - totalCustomPayments) / self.quote.splitPayments.length;

		angular.forEach(self.quote.splitPayments, function(payment) {
			if (!payment.custom) {
				payment.gross = equalGrossPayment;
				payment.net = TaxHelperSvc.netFromGross(payment.gross);
			}
		})
	}

	function grossUpdated(payment) {
		payment.net = TaxHelperSvc.netFromGross(payment.gross);
		recalculateSplitPayments();
	}

	function getSplitAmountTotal() {
		var totalGross = 0;
		angular.forEach(self.quote.splitPayments, function(payment) {
			totalGross += payment.gross;
		});
		return totalGross;
	}

	function submit() {
		if ($scope.formValidator.valid()) {
			if (self.quote.invoice_type == 3 && !self.quote.converted) {
				var splitAmountTotal = getSplitAmountTotal();
				if (Number(splitAmountTotal).toFixed(2) != Number(self.quote.selling_price_gross).toFixed(2)) {
					notify({
						message: 'Split payments total £' + Number(splitAmountTotal).toFixed(2) + ' but the total amount for this job is £' + Number(self.quote.selling_price_gross).toFixed(2),
						classes: 'error'
					});
					return;
				}
			}

			var converting = (self.quote.converted) ? false : true;
			self.processing = true;
			self.quote.converted = true;
			self.quote.converted_date = moment().format('YYYY-MM-DD');
			var copy = angular.copy(self.quote);
			if (moment.isMoment(copy.preferred_time)) {
				copy.preferred_time = copy.preferred_time.format('HH:mm:ss');
			}

			TGJobSvc.save(copy).then(function(response) {
				if (converting) {
					notify({
						message: 'Successfully converted quote'
					});
				}
				else {
					notify({
						message: 'Successfully updated job'
					});
				}
                self.processing = false;
				var showTreatmentPlanPopup = (response.data.customer_tg_job_count > 1 && converting) ? true : false;
                $state.go('main.trugreen.job.index.view', {jobId: response.data.tg_job.id, justNowConverted:showTreatmentPlanPopup });
            }, function(errors) {
				self.errors = errors;
			});

		}
	}

	function splitPaymentDateChanged(paymentIndex){
		if(paymentIndex == 0){
			var firstPayment = self.quote.splitPayments[0];

			angular.forEach(self.quote.splitPayments, function(payment, index) {
				if (index == 0) {
					return;
				}
				payment.date = moment(firstPayment.date).add(index, 'month');
			});
		}
	}

	var self = $scope.TGJobSaveCtrl = {
		options: {},
		formValidator: {},
		processing: false,
		loading: true,
		quote: null,
		methods: {
			init: init,
			initSplitPayments: initSplitPayments,
			addSplitPayment: addSplitPayment,
			removeSplitPayment: removeSplitPayment,
			grossUpdated: grossUpdated,
			submit: submit,
			splitPaymentDateChanged: splitPaymentDateChanged,
		}
	}

});
